<!--鼠标右键-->
<template>
	<div class="right-key" :style="opePos" v-show="fixState">
		<div v-show="opeRectState">
			<div class="key-list fix-color" @click="fixRect">修改选项</div>
			<div class="key-list del-color" @click="delRect">删除选项</div>
		</div>
		<div v-show="opeTitleState">
			<div class="key-list fix-color" @click="fixTitle">修改题号</div>
		</div>
		<div class="key-list close-color" @click="fixState = false">关闭</div>
	</div>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import { cloneDeep, orderBy, sortBy } from 'lodash'
import fixRect from '../utils/mixin/fix-rect'
import { objTopicSorted } from '../utils/js/enum'
import { recognizeExamNo } from '../utils/js/recognise'
export default {
	name: 'temp-right-key',
	mixins: [fixRect],
	data() {
		return {
			//位置
			topPos: 0,
			leftPos: 0,
			//
			rectLeft: 0,
			rectTop: 0,
			rectWidth: 0,
			rectHeight: 0,
			//当前右键内容是否显示
			fixState: false,
			//对于客观题的右键内容
			opeRectState: true,
			//对于考号的右键内容
			opeTitleState: false,
			query: this.$route.query,
			//当前ppi
			currentPpi: {},
			//当前框子的索引
			rectIndex: null,
			//当前ppi 索引
			ppiIndex: null,
			//所有框
			rectItem: [],
			//选做题有两种，似客观题和似主观题
			selLike: null
		}
	},
	watch: {
		//缩放
		tempScalePage() {
			this.fixState = false
		},
		tempRectObjective(val) {
			if (val.state) this.judgeReFix()
		},
		//滚动条滚动的时候自动隐藏
		tempScrollTop() {
			this.fixState = false
			this.opeRectState = true
			this.opeTitleState = false
		},
		//滚动条滚动的时候自动隐藏
		tempScrollLeft() {
			this.fixState = false
			this.opeRectState = true
			this.opeTitleState = false
		},
		//鼠标点击右键的时候  出现   操作位置和显示的内容
		tempRightKeyFixRectInfo(val) {
			this.topPos = val.top * this.tempScalePage - this.tempScrollTop
			this.leftPos = val.left * this.tempScalePage - this.tempScrollLeft
			this.currentPpi = val.ppi
			this.rectIndex = val.rectIndex
			this.ppiIndex = val.ppiIndex
			this.rectItem = val.rectItem
			this.fixState = true
			if (val.isTitle) {
				this.opeRectState = false
				this.opeTitleState = true
			} else {
				this.opeRectState = true
				this.opeTitleState = false
			}
		},
		//重构的轻轻下 隐藏
		tempHandleReset() {
			this.fixState = false
		},
		// 完成复制
		copyObjState(val) {
			this.handleCopyComplete(val)
		}
	},
	computed: {
		...mapGetters('examination/configation', [
			'tabActive',
			'tempSubList',
			'tempObjTopic',
			'copyObjState',
			'tempScalePage',
			'tempScrollTop',
			'tempScrollLeft',
			'tempImgZoomRate',
			'tempEditImgInfo',
			'tempHandleReset',
			'tempObjDirection',
			'tempFillDirection',
			'tempRectObjective',
			'tempCurrentImgIndex',
			'tempTopicCurrentIndex',
			'tempSelLikeSubOrObjVal',
			'tempRightKeyFixRectInfo'
		]),
		opePos() {
			return { top: `${this.topPos}px`, left: `${this.leftPos + 40}px` }
		}
	},
	methods: {
		...mapActions('examination/databases', ['get', 'set']),
		...mapMutations('examination/configation', ['setTempFlushData', 'setTempFixRectTitle', 'setTempExamObjAddRect']),
		// 新建题号
		newTitle() {
			this.fixState = false
		},
		//*******选项****************
		// 微调选项
		fixRect() {
			this.setTempFixRectTitle({
				currentPpi: this.currentPpi,
				rectIndex: this.rectIndex,
				ppiIndex: this.ppiIndex,
				titleState: false,
				rectState: true
			})
			this.fixState = false
		},
		// 删除选区  包括选择题和考号，
		delRect() {
			let rectDetail = this.rectItem
			let appendInfo = JSON.parse(rectDetail.appendInfo)
			let box = JSON.parse(rectDetail.appendInfo).box
			let delBoxIndex = null
			box.forEach((res, index) => {
				if (res.x === this.currentPpi.x && res.y === this.currentPpi.y && res.v === this.currentPpi.v) {
					delBoxIndex = index
					return false
				}
			})
			this.$delete(box, delBoxIndex)
			if (this.tabActive === 'examNo' && box.length % 10 === 0) {
				appendInfo.box = recognizeExamNo(this, box, [], true)
			} else {
				appendInfo.box = box
			}
			rectDetail.appendInfo = JSON.stringify(appendInfo)
			this.refreshArea(rectDetail['pkId'], JSON.stringify(rectDetail)).then(res => {
				if (res.code === 200) {
					this.$message({ type: 'success', message: '删除成功' })
					this.setTempFlushData({ state: true })
					this.fixState = false
				}
			})
		},
		// 判断 添加标题  绑定数据
		async judgeReFix(cb) {
			if (this.tempObjTopic.length === 0 || Object.keys(this.tempObjTopic).length === 0) return false
			let currentNameList = []
			this.tempObjTopic.forEach(res => {
				res.sum = 0
				currentNameList.push(res.key)
				res.val.forEach(response => (res.sum += response.num))
			})
			let tempObjectTopicSorted = []
			objTopicSorted.forEach(res => {
				this.tempObjTopic.forEach(resp => {
					if (res.split('大题')[0] === resp.key.split('大题')[0]) {
						let val = sortBy(resp.val, value => Number(value.smallTopic))
						tempObjectTopicSorted.push({ key: resp.key, sum: resp.sum, val })
					}
				})
			})
			let objTopicNames = tempObjectTopicSorted.reduce((acc, val) => (acc += val.key), '')
			let objLen = 0
			let boxLens = 0
			let boxList = []
			if (this.tempRectObjective.val.length === 0) return false
			objLen = tempObjectTopicSorted.reduce((acc, val) => (acc += val.val.reduce((a, v) => (a += v.num), 0)), 0)
			this.tempRectObjective.val.forEach(responce => {
				let remarks = JSON.parse(responce.remarks)
				if (this.tempCurrentImgIndex.curIndex + 1 === Number(remarks.page) && objTopicNames === remarks.name) {
					if (responce.appendInfo && JSON.parse(responce.appendInfo).box) {
						boxLens += JSON.parse(responce.appendInfo).box.length
					}
					boxList.push(responce)
				}
			})
			let flag = this.tempRectObjective.val.every(res => res || res.remarks)
			if (!flag) return false
			let isDone
			this.tempRectObjective.val.forEach(res => {
				if (JSON.parse(res.remarks).name && JSON.parse(res.remarks).name.includes(currentNameList[0])) {
					isDone = JSON.parse(res.remarks).isDone || false
				}
			})
			if (isDone) return false
			if (this.tabActive === 'objective') {
				if (cb) {
					if (objLen !== boxLens) {
						this.$message.error('客观题选区数量不匹配：' + objLen + '≠' + boxLens)
					} else {
						cb(boxList)
					}
					return
				}
				if (objLen !== 0 && boxLens !== 0 && objLen === boxLens) {
					if (boxList.length > 1) {
						this.setMultipleToOne(boxList)
					} else {
						this.multipleRecognise(boxList, tempObjectTopicSorted)
					}
				}
			}
		},
		//多项识别  选择题 可以是单选，也可与是单选，因为单选是特殊的多选  ，都可以是为单选来搞
		// 设置 单列数  ——————
		async multipleRecognise(boxList, tempObjectTopic) {
			let curBoxList = boxList
			let nowBoxList = curBoxList[0]
			let multipleBoxList = curBoxList[0].boxFromAppendInfo
			let stepHeight = multipleBoxList[0].h
			let stepWidth = multipleBoxList[0].w
			multipleBoxList = orderBy(multipleBoxList, ['y'], ['asc'])
			let topLayInit = multipleBoxList[0]
			let topLayArr = []
			multipleBoxList.forEach(res => {
				if (res.y >= topLayInit.y - 10 && res.y <= topLayInit.y + stepHeight) {
					topLayArr.push(res)
				}
			})
			let leftTopBox = orderBy(topLayArr, ['x'], ['asc'])[0]
			let leftTopBoxObj = {}

			multipleBoxList.forEach(res => {
				if (res.x >= leftTopBox.x - stepWidth && res.x <= leftTopBox.x + stepWidth) leftTopBoxObj[res.y] = res
			})
			let resultInitObj = {}
			for (let key in leftTopBoxObj) {
				if (!resultInitObj[key]) resultInitObj[key] = []
				multipleBoxList.forEach(res => {
					if (res.y >= leftTopBoxObj[key].y - stepHeight * 0.95 && res.y <= leftTopBoxObj[key].y + stepHeight * 0.95) {
						resultInitObj[key].push(res)
						resultInitObj[key] = orderBy(resultInitObj[key], ['x'], ['asc'])
					}
				})
			}

			//------------------------------------------------------------------
			let tempMarkList = []
			let resultObj = {}
			let resultInitObjKey = Object.keys(resultInitObj)
				.map(res => Number(res))
				.sort((a, b) => a - b)
			tempMarkList.push({ y: 0 })
			for (let i = 1; i < resultInitObjKey.length - 1; i++) {
				let prev = resultInitObj[resultInitObjKey[i].toString()][0].y - resultInitObj[resultInitObjKey[i - 1].toString()][0].y
				let next = resultInitObj[resultInitObjKey[i + 1].toString()][0].y - resultInitObj[resultInitObjKey[i].toString()][0].y
				if (next / prev > 1.5) {
					tempMarkList.push(resultInitObj[resultInitObjKey[i] + ''][0])
					tempMarkList.push(resultInitObj[resultInitObjKey[i + 1] + ''][0])
				}
			}
			tempMarkList.push(resultInitObj[resultInitObjKey[resultInitObjKey.length - 1]][0])

			let consludeNum = -1
			for (let step = 0; step < tempMarkList.length; step += 2) {
				consludeNum += 1
				if (!resultObj[consludeNum]) resultObj[consludeNum] = []
				for (let rowKey in resultInitObj) {
					if (
						resultInitObj[rowKey][0].y >= tempMarkList[step].y - stepHeight * 0.6 &&
						resultInitObj[rowKey][0].y <= tempMarkList[step + 1].y + stepHeight * 0.6
					) {
						resultObj[consludeNum] = [...resultObj[consludeNum], ...resultInitObj[rowKey]]
					}
				}
			}
			// //----------------------------------------------------------
			let curSum = 0,
				curIndex = 0,
				curObj = {}
			tempObjectTopic.forEach(resp => {
				resp.val.forEach(res => {
					curSum += res.num
					if (!curObj[curIndex]) curObj[curIndex] = {}
					if (!curObj[curIndex].topic) curObj[curIndex].topic = []
					curObj[curIndex].topic.push(res)
					if (curSum === resultObj[curIndex].length) {
						curObj[curIndex].box = resultObj[curIndex]
						curIndex += 1
						curSum = 0
					}
				})
			})
			let resultBox = []
			let resultTitle = []

			for (let key in curObj) {
				let responce = await this.singleRecognise(curObj[key].box, curObj[key].topic)
				resultBox = [...resultBox, ...responce.resultBox]
				resultTitle = [...resultTitle, ...responce.resultTitle]
			}
			//----------------------------------------------------------
			let appendInfo = JSON.parse(nowBoxList.appendInfo)
			appendInfo.box = resultBox
			nowBoxList.appendInfo = JSON.stringify(appendInfo)
			let remarks = JSON.parse(nowBoxList.remarks)
			remarks.isDone = true
			remarks.title = resultTitle
			nowBoxList.remarks = JSON.stringify(remarks)
			this.refreshArea(nowBoxList.pkId, JSON.stringify(nowBoxList)).then(res => {
				if (res.code === 200) {
					this.fixState = false
					this.setTempFlushData({ state: false })
				}
			})
		},
		// 多选如果是多个，先拆后聚合  重点在这里
		// , delFlag = false
		setMultipleToOne(boxList) {
			if (this.copyObjState.state) return
			const _this = this
			let startX = orderBy(boxList, ['areaMinX'], ['asc'])[0].areaMinX
			let startY = orderBy(boxList, ['areaMinY'], ['asc'])[0].areaMinY
			let endX = orderBy(boxList, ['areaMaxX'], ['desc'])[0].areaMaxX
			let endY = orderBy(boxList, ['areaMaxY'], ['desc'])[0].areaMaxY
			let allBox = []
			// allTitle = [],
			// allOriginData = {}
			// flag = boxList[0].areaMinY
			boxList.forEach(res => {
				let rectBox = JSON.parse(res.appendInfo).box
				// let remarks = JSON.parse(res.remarks)
				rectBox.forEach(ele => {
					allBox.push(
						Object.assign({}, ele, {
							x: ele.x + (res.areaMinX - startX),
							y: ele.y + (res.areaMinY - startY)
						})
					)
				})
				// if (delFlag) {
				// 	remarks.title.forEach(resp => {
				// 		allTitle.push(
				// 			Object.assign({}, resp, {
				// 				x: resp.x + (res.areaMinX - startX),
				// 				y: resp.y + (res.areaMinY - startY)
				// 			})
				// 		)
				// 	})
				// 	if (res.areaMinY >= flag - 50 && res.areaMinY <= flag + 50) {
				// 		if (!allOriginData[flag]) allOriginData[flag] = []
				// 		remarks.handleOrigin.forEach(resp => {
				// 			resp.forEach(ele => {
				// 				ele.x = ele.x + (res.areaMinX - startX)
				// 				ele.y = ele.y + (res.areaMinY - startY)
				// 			})
				// 		})
				// 		allOriginData[flag].push(remarks.handleOrigin)
				// 	} else {
				// 		flag = res.areaMinY
				// 		remarks.handleOrigin.forEach(resp => {
				// 			resp.forEach(ele => {
				// 				ele.x = ele.x + (res.areaMinX - startX)
				// 				ele.y = ele.y + (res.areaMinY - startY)
				// 			})
				// 		})
				// 		allOriginData[flag] = [remarks.handleOrigin]
				// 	}
				// }
			})
			// if (delFlag) {
			// 	return { endX, endY, startX, startY, allBox, allTitle, allOriginData }
			// }
			Promise.resolve()
				.then(() => {
					boxList.forEach(resp => {
						const params = {
							subjectId: _this.query.subjectId,
							examId: _this.query.examId,
							ppiId: resp.pkId
						}
						_this.$post('Cv/rmPpi', params)
					})
				})
				.then(() => {
					_this.addDropRect(endX, endY, startX, startY, allBox)
				})
		},

		// 手动识别  把多个聚合为一个
		setHandleMultipleToOne(boxList, cb) {
			const _this = this
			const conclude = boxList.map(res => {
				res.multiple = res.areaMinX * res.areaMinY
				return res
			})
			let startX = orderBy(boxList, ['areaMinX'], ['asc'])[0].areaMinX
			let startY = orderBy(boxList, ['areaMinY'], ['asc'])[0].areaMinY
			let endX = orderBy(boxList, ['areaMaxX'], ['desc'])[0].areaMaxX
			let endY = orderBy(boxList, ['areaMaxY'], ['desc'])[0].areaMaxY
			const boxFlag = orderBy(conclude, ['multiple'], ['asc'])[0]
			boxFlag.areaMaxX = endX
			boxFlag.areaMaxY = endY
			const resultBox = [],
				resultTitle = []
			Promise.resolve()
				.then(() => {
					boxList.forEach(res => {
						let intervalX = res.areaMinX - startX,
							intervalY = res.areaMinY - startY
						const appendInfo = JSON.parse(res.appendInfo)
						appendInfo.title.forEach(resp => {
							resp.x += intervalX
							resp.y += intervalY
							resultTitle.push(resp)
						})
						res.boxList.forEach(resp => {
							resp.x += intervalX
							resp.y += intervalY
							resultBox.push(resp)
						})
					})
				})
				.then(() => {
					cloneDeep(boxList)
						.slice(1)
						.forEach(resp => {
							const params = {
								subjectId: _this.query.subjectId,
								examId: _this.query.examId,
								ppiId: resp.pkId
							}
							_this.$post('Cv/rmPpi', params)
						})
				})
				.then(() => {
					cb && cb(boxFlag, resultBox, resultTitle)
				})
		},
		// // 手动识别 当填涂方向和题号方向都为横向的情况下
		setHandleDoubleHorizontalMulToOne(boxList, cb) {
			const _this = this
			const conclude = boxList.map(res => {
				res.multiple = res.areaMinX * res.areaMinY
				return res
			})
			const maxX = orderBy(conclude, ['areaMaxX'], ['desc'])[0]['areaMaxX']
			const maxY = orderBy(conclude, ['areaMaxY'], ['desc'])[0]['areaMaxY']
			const boxFlag = orderBy(conclude, ['multiple'], ['asc'])[0]

			const intervalWidth = (boxFlag.areaMaxX - boxFlag.areaMinX) * 0.5
			const intervalHeight = (boxFlag.areaMaxY - boxFlag.areaMinY) * 0.5
			let standardColumn = []
			boxList.map(res => {
				if (boxFlag.areaMinX + intervalWidth >= res.areaMinX && boxFlag.areaMinX - intervalWidth <= res.areaMinX) {
					standardColumn.push(res)
				}
			})
			let resultObj = {},
				max
			standardColumn.forEach(res => {
				if (!resultObj[res.areaMinY]) resultObj[res.areaMinY] = { max: 0, val: [] }
				boxList.forEach(resp => {
					max = 0
					if (res.areaMinY + intervalHeight >= resp.areaMinY && res.areaMinY - intervalHeight <= resp.areaMinY) {
						Promise.resolve()
							.then(() => {
								sortDoubleRow(res.boxList, function(val) {
									const resultVal = Object.entries(val)
									resultVal.sort((a, b) => {
										return Number(a[0]) - Number(b[0])
									})
									resp.resultBoxList = resultVal
									max = Math.max(max, resp.resultBoxList.length)
								})
							})
							.then(() => {
								resultObj[res.areaMinY].max = max
								resultObj[res.areaMinY].val.push(resp)
							})
					}
				})
			})
			setTimeout(() => {
				let allTempTopic = [],
					resultAllBox = [],
					resultAllTitle = []
				this.tempObjTopic.forEach(res => allTempTopic.push(...res.val))
				allTempTopic = sortBy(allTempTopic, ele => Number(ele.smallTopic))
				let start = 0
				for (let row in resultObj) {
					const cols = resultObj[row]['val']
					const sum = resultObj[row]['max']
					let i = 0
					while (i < sum) {
						cols.forEach((res, index) => {
							const concludeX = res.areaMinX - boxFlag.areaMinX
							const concludeY = res.areaMinY - boxFlag.areaMinY
							if (res.resultBoxList[i]) {
								const cur = cloneDeep(res.resultBoxList[i][1])
								const concludeCur = cur.map(resp => {
									resp.n = allTempTopic[start].pkId
									resp.x += concludeX
									resp.initX = resp.x
									resp.y += concludeY
									resp.initY = resp.y
									return resp
								})
								const first = cloneDeep(concludeCur[0])
								first.x -= 50
								first.v = allTempTopic[start].smallTopic
								resultAllBox.push(...concludeCur)
								resultAllTitle.push(first)
								start++
							}
							if (index === cols.length - 1) i++
						})
					}
				}
				cloneDeep(boxList)
					.slice(1)
					.forEach(resp => {
						const params = {
							subjectId: _this.query.subjectId,
							examId: _this.query.examId,
							ppiId: resp.pkId
						}
						_this.$post('Cv/rmPpi', params)
					})
				const resultBox = cloneDeep(boxFlag)
				resultBox.areaMaxX = maxX
				resultBox.areaMaxY = maxY
				cb && cb(resultBox, resultAllBox, resultAllTitle)
			})

			// todo 这块需要操作下  这块代码一定是和别的地方的代码有重复的   但是现在暂时放下来  以后了优化
			function sortDoubleRow(boxList, cb) {
				const orderByRow = orderBy(boxList, ['x'], ['asc']).slice(0, 8)
				const orderByColumn = orderBy(orderByRow, ['y'], ['asc'])[0]
				const standCol = []
				boxList.forEach(res => {
					if (orderByColumn.x + orderByColumn.w * 0.6 >= res.x && orderByColumn.x - orderByColumn.w * 0.6 <= res.x) standCol.push(res)
				})
				let resultObj = {}
				standCol.forEach(resp => {
					if (!resultObj[resp.y]) resultObj[resp.y] = []
					boxList.forEach(responce => {
						if (resp.y + orderByColumn.h * 0.6 >= responce.y && resp.y - orderByColumn.h * 0.6 <= responce.y) {
							resultObj[resp.y].push(responce)
						}
					})
				})
				cb(resultObj)
			}
		},
		// 单项 识别 选择题
		singleRecognise(boxList, tempObjectTopic) {
			const _this = this
			return import('../utils/js/recognise').then(res => {
				return res.recognizeObjective(_this, boxList, tempObjectTopic, _this.tempObjDirection, _this.tempFillDirection)
			})
		},
		// 更新区块
		async refreshArea(ppiId, ppiStr) {
			const params = {
				subjectId: this.query.subjectId,
				examId: this.query.examId,
				versionId: this.tempEditImgInfo.versionId,
				ppiId: ppiId,
				ppiStr: ppiStr
			}
			return this.$post('Cv/refreshPpi', params).then(res => {
				return res
			})
		},
		//*******标题****************
		// 修改标题
		fixTitle() {
			this.setTempFixRectTitle({
				currentPpi: this.currentPpi,
				rectIndex: this.rectIndex,
				ppiIndex: this.ppiIndex,
				titleState: true,
				rectState: false
			})
			this.fixState = false
		},
		//	手动识别  完成复制完成复制
		handleCopyComplete(val) {
			if (val.state) return
			const _this = this
			this.judgeReFix(function(allBox) {
				// 手动配置 有两中情况
				if (_this.tempObjDirection === 'H' && _this.tempFillDirection === 'H') {
					//1.题号未识别   直接这样可能不对
					// _this.setTempFlushData({ state: true })
					_this.setHandleDoubleHorizontalMulToOne(allBox, function(boxFlag, resultBox, resultTitle) {
						handleResult(boxFlag, resultBox, resultTitle)
					})
				} else {
					// 2. 题号已识别
					_this.setHandleMultipleToOne(allBox, function(boxFlag, resultBox, resultTitle) {
						handleResult(boxFlag, resultBox, resultTitle)
					})
				}
			})
			// 题号和填图方向都为横向的情况下
			// 操作完成
			function handleResult(boxFlag, allBox, allTitle) {
				let appendInfo = JSON.parse(boxFlag.appendInfo)
				appendInfo.box = allBox
				let remarks = JSON.parse(boxFlag.remarks)
				remarks.title = allTitle
				remarks.isDone = true
				boxFlag.appendInfo = JSON.stringify(appendInfo)
				boxFlag.remarks = JSON.stringify(remarks)
				_this.refreshArea(boxFlag.pkId, JSON.stringify(boxFlag)).then(res => {
					if (res.code === 200) {
						_this.setTempFlushData({ state: false })
					}
				})
			}
		}
	}
}
</script>

<style scoped lang="less">
.right-key {
	width: 80px;
	position: absolute;
	z-index: 100;
	background: #ffffff;
	padding: 5px 0;
	border-radius: 3px;
	box-shadow: 0 0 15px #000;
	box-sizing: border-box;
	.key-list {
		width: 100%;
		line-height: 25px;
		font-size: 13px;
		padding: 0 10px 0 10px;
		position: relative;
		border-bottom: 1px solid #ebebeb;
		box-sizing: border-box;
		color: #272626;
		&:nth-last-child(1) {
			border-bottom: none;
		}
		&:hover {
			cursor: pointer;
			font-size: 15px;
			font-weight: bolder;
		}
	}
	.add-color {
		color: #009688;
	}
	.fix-color {
		color: #409eff;
	}
	.close-color {
		color: black;
		border-top: 1px solid #ebebeb;
	}
	.rotate-color {
		color: #f3d40a;
	}
	.del-color {
		color: #ff6f1b;
	}
}
</style>
